// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IStatisticInfoDto } from './IStatisticInfoDto';
import {
    IStatisticInfoDtoFromJSON,
    IStatisticInfoDtoFromJSONTyped,
    IStatisticInfoDtoToJSON,
    IStatisticInfoDtoToJSONTyped,
} from './IStatisticInfoDto';

/**
 * 
 * @export
 * @interface IExpenseStatisticsResponseDto
 */
export interface IExpenseStatisticsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IExpenseStatisticsResponseDto
     */
    total_expenses?: number;
    /**
     * 
     * @type {Array<IStatisticInfoDto>}
     * @memberof IExpenseStatisticsResponseDto
     */
    expenses?: Array<IStatisticInfoDto>;
}

/**
 * Check if a given object implements the IExpenseStatisticsResponseDto interface.
 */
export function instanceOfIExpenseStatisticsResponseDto(value: object): value is IExpenseStatisticsResponseDto {
    return true;
}

export function IExpenseStatisticsResponseDtoFromJSON(json: any): IExpenseStatisticsResponseDto {
    return IExpenseStatisticsResponseDtoFromJSONTyped(json, false);
}

export function IExpenseStatisticsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpenseStatisticsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_expenses': json['total_expenses'] == null ? undefined : json['total_expenses'],
        'expenses': json['expenses'] == null ? undefined : ((json['expenses'] as Array<any>).map(IStatisticInfoDtoFromJSON)),
    };
}

export function IExpenseStatisticsResponseDtoToJSON(json: any): IExpenseStatisticsResponseDto {
    return IExpenseStatisticsResponseDtoToJSONTyped(json, false);
}

export function IExpenseStatisticsResponseDtoToJSONTyped(value?: IExpenseStatisticsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_expenses': value['total_expenses'],
        'expenses': value['expenses'] == null ? undefined : ((value['expenses'] as Array<any>).map(IStatisticInfoDtoToJSON)),
    };
}

